module.exports = __webpack_public_path__ + "img/ch84.f38acbf5.png";